import { liveStatusEnum } from "@/libs/live/const";
import { formatDate } from "@/utils/date-format";
import moment from "moment";
import React, { useCallback, useMemo } from "react";
import styles from "./index.module.scss";

interface PreheatFooterProps {
  isAppointment?: boolean;
  planBeginTime?: number;
  liveStatus?: number;
  couponType?: number;
  onSubScribe?: () => void; //订阅开播提醒
  onGoToLive?: (liveStatus?: number) => void; //跳转直播
  children?: {
    sub?: React.ReactNode;
    subed?: React.ReactNode;
    live?: React.ReactNode;
  };
}

const PreheatFooter: React.FC<PreheatFooterProps> = ({
  isAppointment = false,
  planBeginTime,
  liveStatus = 0,
  couponType = 0,
  onSubScribe,
  onGoToLive,
  children,
}) => {
  // 开播时间
  let _planBeginTime = formatDate(new Date(planBeginTime as number));

  try {
    _planBeginTime = moment(planBeginTime).format("YYYY-MM-DD HH:mm");
  } catch (error) {
    console.error("格式化时间失败", error);
  }

  // 计算订阅按钮代码段
  const getSubscribeBtnFragment = useMemo(() => {
    // 已开播
    if (liveStatus != liveStatusEnum.LIVE_STATUS_PENDING) {
      return (
        <div
          className={`${styles.timeBtn} ${styles.alignCenter}`}
          onClick={() => onGoToLive && onGoToLive(liveStatus)}>
          <img
            src="https://akmer.aikucun.com/4d654e4716b1e431b85ae9628a3915fa2d807bfd_1602737517267_69.png"
            alt=""
          />
          {children?.live || "观看直播"}
        </div>
      );
    }
    // 未开播
    // 已订阅
    if (isAppointment) {
      return (
        <div className={`${styles.timeBtn} ${styles.alignCenter} ${styles.isAppointed}`}>
          {children?.subed || "已提醒"}
        </div>
      );
    }
    // 未订阅
    // return (
    //   <div
    //     className={`${styles.timeBtn} ${styles.alignCenter}`}
    //     onClick={onSubScribe}
    //   >
    //     <img src="https://akmer.aikucun.com/951e4087a974076d7c480b4f5b6df8c7915d596b_1602732313944_99.png" alt="" />
    //     {children?.sub || "开播提醒"}
    //   </div>
    // );
  }, [liveStatus, isAppointment, children, onGoToLive, onSubScribe]);

  return (
    <div className={styles.bottomWrap}>
      {/* VIP专属优惠券tips */}
      {couponType === 1 && (
        <div className={styles.coupon}>
          <img
            src="https://akmer.aikucun.com/805856b77541be3e449e719348a836157bd522eb_1600223998780_56.png"
            alt=""
          />
          <p>本场直播包含专属优惠券，记得订阅开播提醒</p>
        </div>
      )}

      <div className={`${styles.footer} ${styles.justifyBetween}`}>
        <div className={`${styles.timeBox} ${styles.alignCenter}`}>
          <img
            src="https://akmer.aikucun.com/bff3acfed1a57f600ad7f683889e8eee6b418e0b_1602732284771_35.png"
            alt=""
          />
          <span>开播时间 {_planBeginTime}</span>
        </div>

        {/* 订阅按钮代码段 */}
        {getSubscribeBtnFragment}
      </div>
    </div>
  );
};

export default PreheatFooter;
